import { Group } from "@mantine/core";
import React from "react";
import UserDisableCreateOrderButton from "./userDisableCreateOrderButton";
import UserActiveEnableButton from "./userActiveEnableButton";
import UserLeaveActionButton from "./userLeaveActionButton";
import UserWalletActiveButton from "./userWalletActiveButton";
import UserEditButton from "./userEditButton";
import UserSetPasswordButton from "./userSetPasswordButton";
import UserTransferClientButton from "./userTransferClientButton";
import ActionPermissionGate from "./actionPermissionGate";

const UserActionList = ({ form }) => {
  return (
    <Group mt={10}>
      <ActionPermissionGate entity="user" action="editUser">
        <UserEditButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="user" action="setPassword">
        <UserSetPasswordButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="user" action="disableCreateOrder">
        <UserDisableCreateOrderButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="user" action="activeEnable">
        <UserActiveEnableButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="user" action="walletActive">
        <UserWalletActiveButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="user" action="leaveAction">
        <UserLeaveActionButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="user" action="transferClient">
        <UserTransferClientButton mainForm={form} />
      </ActionPermissionGate>
    </Group>
  );
};

export default UserActionList;
